import Gold from 'assets/images/gold.svg'
import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import iconColor from 'components/iconColor'
import FasIdCard from 'components/Legacy/Icons/FasIdCard'
import FasUnlockAlt from 'components/Legacy/Icons/FasUnlockAlt'
import Row from 'components/Row'
import Text from 'components/Text'
import formName from 'constants/formName'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'
import { px } from 'utils'

import Container from '../Modal/Container'

type PropsType = { form: string } & WrappedComponentProps

const ColumnTitle = styled(Column)`
  margin-bottom: 1.2rem;
`

const Unlock = styled(FasUnlockAlt)`
  ${iconColor('blue600')};
  margin-bottom: 1rem;
`

const IdCard = styled(FasIdCard)`
  ${iconColor('blue600')};
  margin-bottom: 1rem;
`

const GoldImage = styled.img`
  height: 4rem;
  margin-bottom: 1.5rem;
`

const Title = styled(Row)`
  margin-bottom: 0.5rem;
`

const Col = styled(Column)`
  margin-bottom: 3rem;
  text-align: center;
  align-items: center;
`

const Description = styled(Text)`
  padding-left: 2rem;
`

const Welcome = ({ form, intl }: PropsType) => (
  <Container
    sub={form === formName.TIER_TWO ? null : intl.formatMessage(messages.sub_title_more_info)}
    title={
      form === formName.TIER_TWO ? (
        <ColumnTitle>
          <GoldImage src={Gold} />
          {intl.formatMessage(messages.title_welcome_gold)}
        </ColumnTitle>
      ) : (
        intl.formatMessage(messages.title_more_info)
      )
    }
    theme='dark'
  >
    <Column>
      <Col>
        <Unlock size={px(1.8)} />
        <Title alignItems='center'>
          <Text color='white' size='lg' weight={600}>
            {intl.formatMessage(messages.higher_limits)}
          </Text>
        </Title>

        <Description color='dark300' size='md'>
          {intl.formatMessage(messages.increase_trading_limits)}
        </Description>
      </Col>

      <Col>
        <IdCard size={px(1.8)} />
        <Title alignItems='center'>
          <Text color='white' size='lg' weight={600}>
            {intl.formatMessage(messages.description_veriff)}
          </Text>
        </Title>

        <Description color='dark300' size='md'>
          {intl.formatMessage(messages.description_veriff_extra)}
        </Description>
      </Col>
    </Column>

    <CeruleanButton e2e='nextButton' type='submit'>
      {intl.formatMessage(messages.button_next)}
    </CeruleanButton>
  </Container>
)

export default injectIntl(Welcome)
